import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/customers',
        name: 'customers',
        meta: { sideMenuLabel: "Clienti" },
        component: () => import("./views/customers.vue")
    },
    {
        path: '/customers/:identifier',
        name: 'customersDetail',
        meta: { classes: "" },
        component: () => import("./views/customersDetail.vue")
    },
];

export default routes;